/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * PoliciesState represents the state of the policies generation.   - ACCEPTED: ACCEPTED is the state when the policies async generation is ongoing.  - CREATED: CREATED is the state when the policies have been generated.  - FAILED: FAILED is the state when the policies generation failed.
 * @export
 * @enum {string}
 */

export const CastaiRbacV1beta1PoliciesState = {
    UNKNOWN: 'UNKNOWN',
    ACCEPTED: 'ACCEPTED',
    CREATED: 'CREATED',
    FAILED: 'FAILED'
} as const;

export type CastaiRbacV1beta1PoliciesState = typeof CastaiRbacV1beta1PoliciesState[keyof typeof CastaiRbacV1beta1PoliciesState];



